import { getProfile } from "../apis/getProfile";
import { APP_ROUTES, normalizeAppPath } from "../constants/appRoutes";
import { isBusinessProfileEmpty, normalizeBusinessProfile } from "./isBusinessProfileEmpty";

function isSafeRedirect(path) {
  const normalized = normalizeAppPath(path);
  if (!normalized) return false;
  if (!normalized.startsWith("/") || normalized.startsWith("//")) return false;
  return true;
}

/**
 * Whether the logged-in user still needs to create a business profile.
 */
export async function needsBusinessProfileSetup() {
  try {
    const data = await getProfile();
    return isBusinessProfileEmpty(normalizeBusinessProfile(data));
  } catch (error) {
    if (error?.response?.status === 404) {
      return true;
    }
    return false;
  }
}

/**
 * Where to send the user after login/activation when no explicit in-app redirect applies.
 * New accounts without a business profile go to profile create.
 */
export default async function resolvePostAuthPath(redirect) {
  const normalizedRedirect = normalizeAppPath(redirect);
  if (normalizedRedirect && isSafeRedirect(normalizedRedirect)) {
    return normalizedRedirect;
  }

  if (await needsBusinessProfileSetup()) {
    return APP_ROUTES.PROFILE_CREATE;
  }

  return APP_ROUTES.HOME;
}
